var map = {
	"./ADA.svg": 811,
	"./BCH.svg": 812,
	"./BNB.svg": 813,
	"./BTC.svg": 814,
	"./CHZ.svg": 815,
	"./DASH.svg": 816,
	"./DOGE.svg": 817,
	"./DOT.svg": 818,
	"./ETC.svg": 819,
	"./ETH.svg": 820,
	"./EUR.svg": 821,
	"./GBP.svg": 822,
	"./LINK.svg": 823,
	"./LTC.svg": 824,
	"./MATIC.svg": 825,
	"./MKR.svg": 826,
	"./SHIB.svg": 827,
	"./SOL.svg": 828,
	"./TRX.svg": 829,
	"./UNI.svg": 830,
	"./USD.svg": 831,
	"./USDT.svg": 832,
	"./XLM.svg": 833,
	"./XMR.svg": 834,
	"./XRP.svg": 835,
	"./documents.svg": 836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;